<template>
  <div>
    <h2 class="text-center mb-4">{{'auth.resetPassword' | translate}}</h2>
    <div class="text-center" v-text="$t('auth.set_a_new_password')"/>
    <form v-on:submit.prevent="reset" class="evollu-form">
      
      <div>
        <div class="row">
          <div class="col-12">
            <label class="form-label">{{$t('users.inputs.password')}}</label>
            <va-input
              id="user-password"
              autocomplete="off"
              required="true"
              :type="passwordInputType"
              v-model="password"
              :placeholder="$t('users.inputs.password')"
              :error="invalidPassword"
              :error-messages="[$t('users.inputs.invalid_password')]"
            >
              <span slot="append" @click="togglePasswordInputType('passwordInputType')">
                <va-icon
                  class="clickable"
                  :class="{'i-evollu-password-show': passwordInputType === 'password','i-evollu-password-hide': passwordInputType !== 'password'}"
                />
              </span>
            </va-input>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <label class="form-label">{{$t('users.inputs.password_confirmation')}}</label>
            <va-input
              id="user-password-confirmation"
              autocomplete="off"
              required="true"
              :type="passwordConfirmationInputType"
              v-model="passwordConfirmation"
              :placeholder="$t('users.inputs.password_confirmation')"
              :error="nonMatchingPassword"
              :error-messages="[$t('users.inputs.different_password')]"
            >
              <span slot="append" @click="togglePasswordInputType('passwordConfirmationInputType')">
                <va-icon
                  class="clickable"
                  :class="{'i-evollu-password-show': passwordConfirmationInputType === 'password','i-evollu-password-hide': passwordConfirmationInputType !== 'password'}"
                />
              </span>
            </va-input>
          </div>
        </div>

      </div>
      
      <small v-if="error" class="d-flex justify-content-center align-items-center text-danger">
        {{ error }}
      </small>
      
      <!-- Submit -->
      <div class="d-flex flex-column flex-lg-row align-items-center justify-content-center down-container" style="margin-top: 4rem !important;">
        <va-button
          v-if="!success"
          class="btn btn-primary btn-block w-75"
          type="submit"
          :disabled="formIsDisabled">

          {{ $t('auth.change_password')}}
        </va-button>
        <va-button 
          v-if="error"
          @click="goToLoginPage"
          v-text="$t('evocall.requests.actions.exit')"
        />
      </div>
    </form>
    <div class="loading" v-show="isLoading">
      <hollow-dots-spinner
        :animation-duration="2500"
        :size="60"
        color="#29c4a9"
      />
    </div>
  </div>
</template>

<script>
import { HollowDotsSpinner } from 'epic-spinners'
import { PASSWORD_REGEX } from '@/utils/regex'

export default {
  name: 'resetpassword',
  components: {
    HollowDotsSpinner
  },
  data () {
    return {
      password: null,
      passwordConfirmation: null,
      error: null,
      isLoading: false,
      success: null,
      passwordInputType: 'password',
      passwordConfirmationInputType: 'password'
    }
  },
  methods: {
    togglePasswordInputType: function (field) {
      this[field] = this[field] === 'password' ? 'text' : 'password'
    },
    transformError (error) {
      return error.replace(/ /g, '_').toLowerCase()
    },
    reset () {
      this.$http({
        url: this.$store.state.evollauth_server + '/auth/' + this.$route.params.id + '/resetpassword/' + this.$route.params.token,
        data: { password: this.password, passwordconfirmation: this.passwordConfirmation },
        method: 'PATCH'
      }).then((response) => {
        this.showToast(this.$t('auth.password_changed'), this.$store.state.successToastOptions)
        this.password = null
        this.passwordConfirmation = null
        this.$router.push({ name: 'login', params: { message: this.success } })
      }).catch((error) => {
        console.log(error.response)
        if (error.response.status === 422) {
          this.error = this.$t('server_auth.errors.' + this.transformError(error.response.data.errors[0].msg))
        } else if (error.response.status === 404 || error.response.status === 405) {
          this.error = this.$t('server_auth.errors.reset_token_expired')
        } else {
          this.error = error.response.data.message
        }
      })
    },
    goToLoginPage(){
      this.$router.push({ name: 'login'})
    }
  },
  computed: {
    formIsDisabled: function () {
      return this.isLoading || this.invalidPassword || !this.password || !this.passwordConfirmation || this.nonMatchingPassword
    },
    invalidPassword: function () {
      if (this.password) {
        return !this.password.match(PASSWORD_REGEX)
      }
      return false
    },
    nonMatchingPassword: function () {
      if (this.password && !this.invalidPassword && this.passwordConfirmation) {
        return this.password !== this.passwordConfirmation
      }
      return false
    }
  }
}
</script>

<style lang="scss">

  .loading {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 40%;
    left: 50%;
  }

</style>
